import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []

  connect() {
    this.checkActive()
  }

  checkActive() {
    const href = this.element.getAttribute('href')
    if (href && window.location.pathname === href) {
      this.element.classList.add('selected')
    }
  }
}
